import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const FormSection = ({ number, title, status, summary, onEdit, children }) => {
    const showBody = status === 'active' || status === 'completing'
    const showCheck = status === 'complete' || status === 'completing'

    return (
        <div className={`inquiry-section inquiry-section--${status}`}>
            <div className="inquiry-section__header">
                <div className="inquiry-section__header-left">
                    <span className="inquiry-section__number">
                        {showCheck
                            ? <FontAwesomeIcon icon="check" />
                            : number
                        }
                    </span>
                    <span className="inquiry-section__title">{title}</span>
                </div>
                {status === 'complete' && (
                    <button type="button" className="inquiry-section__edit-btn" onClick={onEdit}>
                        Edit
                    </button>
                )}
            </div>
            {status === 'complete' && summary && (
                <div className="inquiry-section__summary">{summary}</div>
            )}
            {showBody && (
                <div className={`inquiry-section__body ${status === 'completing' ? 'inquiry-section__body--exit' : 'inquiry-section__body--enter'}`}>
                    {children}
                </div>
            )}
        </div>
    )
}

export default FormSection
